import { styled } from 'mz-ui-kit'

export const PickupTimelineWrapper = styled('div', {
  margin: '12px 0 20px 0'
});

export const FlightPickupAlertWrapper = styled('div', {
  margin: '12px 0 20px 0'
});
